//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SurveyOptions',

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'radio',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selected: this.value,
    }
  },

  methods: {
    doSelect(item) {
      if (this.type === 'radio') {
        this.selected = [item.id]
      } else {
        const index = this.selected.findIndex((id) => id === item.id)
        if (index === -1) {
          this.selected.push(item.id)
        } else {
          this.selected.splice(index, 1)
        }
      }
      this.$emit(
        'select',
        this.options.filter((i) => this.selected.includes(i.id))
      )
    },
  },
}
